import { hasCookie } from './utils';

const routes = {
    csrf: 'auth/csrf-cookie',
    login: 'auth/login', // token and cookie auth
    logout: 'auth/logout',
    me: 'me',
};

async function fetchCsrfToken() {
    await window.centralAxios.get(routes.csrf);
}

async function login(credentials) {
    await fetchCsrfToken();
    const response = await window.centralAxios.post(routes.login, credentials);
    return response.data;
}

async function logout(silent = false) {
    await window.centralAxios.post(routes.logout, null, {
        xSilent: silent,
    });
}

async function me() {
    return window.centralAxios.get(routes.me);
}

function hasXsrfToken() {
    return hasCookie('XSRF-TOKEN');
}

export default {
    fetchCsrfToken,
    login,
    logout,
    me,
    hasXsrfToken,
};
